var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Container"},[_c('ContentTop',{attrs:{"activeKey":2},on:{"searchData":_vm.searchData}}),_c('BlackList',{attrs:{"tableData":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }